// Simple localStorage-based consent store (versioned)
const CONSENT_KEY = "bu_consent_v1";

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : { decided: false, analytics: false };
  } catch {
    return { decided: false, analytics: false };
  }
}

export function setConsent(consent) {
  localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
}

// ---- Loaders (only call after consent.analytics === true) ----
export function loadGA({ measurementId }) {
  if (!measurementId) return;
  if (window.gtag) return; // already loaded

  // dataLayer + stub
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  // Consent mode (optional but good practice)
  gtag("consent", "default", {
    ad_user_data: "denied",
    ad_personalization: "denied",
    ad_storage: "denied",
    analytics_storage: "granted",
    functionality_storage: "granted",
    security_storage: "granted",
  });

  // Load GA
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(s);

  gtag("js", new Date());
  // In SPA we usually disable auto page view and send manually
  gtag("config", measurementId, { send_page_view: false });
}

export function sendGAPageView({ path, title }) {
  if (!window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title || document.title,
  });
}

export function loadHotjar({ id, sv }) {
  if (!id || !sv) return;
  if (window.hj) return; // already loaded

  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: id, hjsv: sv };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}

export function hotjarStateChange(path) {
  if (window.hj) window.hj("stateChange", path);
}
